import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { MatDialog } from "@angular/material/dialog";
import { ShowsService } from "../services/shows.service";
import { DatePipe } from "@angular/common";
import { ConfirmPopupComponent } from "../common/confirm-popup/confirm-popup.component";
import { filter, interval } from "rxjs";
import { DatabaseService } from "../services/database.service";
import { ActivatedRoute } from '@angular/router';
import { Show } from '../interfaces/show.interface';
import { environment } from "../../environments/environment";
import { Font } from "ngx-font-picker";
import { CollaboratorsService } from '../services/collaborators.service';
import { UserService } from 'src/app/services/user.service';
import WaveSurfer from 'wavesurfer.js';
import TimelinePlugin from "node_modules/wavesurfer.js/dist/plugins/timeline.js";
import { AuthService } from "../services/auth/auth.service";
import { set } from 'date-fns';
import { Router } from '@angular/router';

@Component({
	selector: 'app-single-show',
	templateUrl: './single-show.component.html',
	styleUrls: ['./single-show.component.scss'],
	standalone: false
})
export class SingleShowComponent implements OnInit, AfterViewInit {

	public processing: boolean;
	isAdmin: any = true;
	subscription_plan: any;
	loder = false
	public show!: Show;
	public brand: any = null;
	public font: any = new Font();
	public fileInfo: any;
	public fileChanged = false;
	public loaded = false;
	public progress = 0;
	public retried = 0
	public loadingError = false
	public fileError = false
	public newAudioFile = false;
	public timeDifference = 0;
	public timeOffset = ((new Date()).getTimezoneOffset() + (this.isDST() ? 60 : 0)) * 60 * 1000;
	public seekTime = new Date(this.timeOffset);
	public secondsCounter = interval(1000);
	public subscription: any;
	public countdown = 0;
	public adjustment = 0;
	public globalAdjustment = 0;
	public defaultAdjustment = 0;
	public updatingShow = false;
	public timeout: any = null;
	public interactionAllowed = true;
	public interacting = false;
	public played = false;
	public isPublic = false;
	public show_code: any;
	public audioLength = 0;
	public isPyrocast = true;
	public siteName = "Pyrocast"
	public isTune2 = false;
	public ignite = false;
	public listening = false;
	public random = 0;
	public timestampStartTime = 0;
	public timestampStartTime2 = 0;
	public downloadLogged = false
	public listenLogged = false
	public wave: WaveSurfer | undefined;
	buttonVisible = true;
	public socket: WebSocket | undefined;
	@ViewChild('audio') audioElement: ElementRef | undefined;
	announcementComment: string = '';

	email = '';
	socketClock = 0;
	webSocketMessageCount = 0;

	calibrationCount = 0
	isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	playerStartTriggerTs = 0;


	constructor(
		private showService: ShowsService,
		private cdr: ChangeDetectorRef,
		public datepipe: DatePipe,
		private db: DatabaseService,
		private route: ActivatedRoute,
		public dialog: MatDialog,
		public auth: AuthService,
		public router: Router,
		public UserService: UserService,
	) {
		this.auth.authorize().then((authorized) => {
			if (authorized) {
				this.auth.isAdmin.subscribe(val => {
					this.isAdmin = val;
				});
			}
		})


		if (window.location.hostname == environment.skyDomain) {
			this.isPyrocast = false;
			this.ignite = false;
			this.siteName = 'SkyStreamEvents'
			this.email = 'help@skystreamevents.com';
		}
		if (window.location.hostname == environment.igniteDomain) {
			this.isPyrocast = false;
			this.isTune2 = false;
			this.ignite = true;
			this.siteName = 'IGNITE LIVE'
			this.email = 'help@ignitefiringsystems.com';
		}
		if (window.location.hostname == environment.tune2Domain || window.location.hostname == environment.tune2Domain2) {
			this.isPyrocast = false;
			this.ignite = false;
			this.isTune2 = true;
			this.siteName = 'Tune2'
			this.email = 'help@tune2.app';
		}
		else {
			this.email = 'help@pyrocast.com'
		}
		this.processing = false;
		this.font.family = 'Roboto';
		this.random = Math.random();
		this.updateTimer();

	}
	formatTime(time: string): string {
		let [hours, minutes] = time.split(':');
		let period = 'AM';

		let hoursNumber = parseInt(hours, 10); // Parse hours as a number

		if (hoursNumber >= 12) {
			period = 'PM';
			hoursNumber = hoursNumber > 12 ? hoursNumber - 12 : hoursNumber;
		} else if (hoursNumber === 0) {
			hoursNumber = 12;
		}

		return `${hoursNumber}:${minutes} ${period}`;
	}

	isDST() {
		let d = new Date();
		let jan = new Date(d.getFullYear(), 0, 1).getTimezoneOffset();
		let jul = new Date(d.getFullYear(), 6, 1).getTimezoneOffset();
		return Math.max(jan, jul) !== d.getTimezoneOffset();
	}

	ngOnInit(): void {


		if (window.localStorage.getItem('adjustment')) {
			this.globalAdjustment = Number(window.localStorage.getItem('adjustment'));
		}

		// let tsValues = {
		// 	T1_Client: 0,
		// 	T2_Server: 0,
		// 	T3_Client: 0,
		// 	T4_Server: 0,
		// 	T5_Client: 0,
		// 	RTT: 0,
		// 	T_to: 0
		// };
		// this.timestampStartTime = (+ new Date());
		// tsValues.T1_Client = this.timestampStartTime;
		// this.showService.getTimestamp().subscribe(response => {
		// 	tsValues.T2_Server = (+new Date(response.timestamp));

		// 	this.timestampStartTime -= (+ new Date());
		// 	this.timestampStartTime2 = (+ new Date());
		// 	tsValues.T3_Client = this.timestampStartTime2
		// 	this.showService.getTimestamp().subscribe(response => {
		// 		tsValues.T4_Server = response.timestamp
		// 		this.timestampStartTime2 -= (+ new Date());
		// 		tsValues.T5_Client = (+ new Date());
		// 		tsValues.RTT = tsValues.T5_Client - tsValues.T1_Client
		// 		tsValues.T_to = (tsValues.T2_Server - tsValues.T1_Client + tsValues.T4_Server - tsValues.T3_Client) / 2
		// 		console.log(tsValues);
		// 		this.db.setTimeData(this.show_code, tsValues);
		// 		console.log(((this.timestampStartTime+this.timestampStartTime2)/2) + " milliseconds");
		// 		console.log((+(new Date())  - this.timeDifference ) % 1000);
		// 		let ts = (+ new Date());
		// 		this.timeDifference = ts - response.timestamp + (this.timestampStartTime+this.timestampStartTime2)/2;
		// 		this.timeDifference = tsValues.T_to;
		// 		console.log(this.timeDifference + " milliseconds");
		// 		// setTimeout(() => {
		// 		// 	this.secondsCounterFunc();
		// 		// }, (+(new Date())  - this.timeDifference ) % 1000);
		// 		//if(this.timeDifference)
		// 		console.log("Time Difference is: " + this.timeDifference);
		// 		//this.timeDifference = 0;
		// 		//console.log(this.timeDifference);
		// 	});
		// });
		this.socket = new WebSocket('wss://timing-ws.pyrocast.com');
		this.socket.onerror = (error) => {
			console.error('WebSocket error:', error);
		};

		this.socket.onclose = () => {
			console.log('WebSocket connection closed');
		};
		const tsValues = {
			T1_Client: 0,
			T2_Server: 0,
			T3_Client: 0,
			RTT: 0,
			T_to: 0
		}
		if (this.socket) {
			this.socket.onmessage = (event) => {
				tsValues.T3_Client = (+ new Date())
				tsValues.RTT = tsValues.T3_Client - tsValues.T1_Client
				const data = JSON.parse(event.data);
				//console.log(data);
				if (this.socketClock == 0) { // Clock Start Time on First Message
					this.socketClock = +new Date();
					setInterval(() => {
						this.socketClock += 50;
					}, 50);

				}
				if (this.webSocketMessageCount < 5) {
					this.timeDifference = (+new Date() - data.timestamp)
					tsValues.T2_Server = data.timestamp;
					tsValues.T_to = this.timeDifference;
					console.log("Time Difference is: " + this.timeDifference);
				}
				this.webSocketMessageCount++;
				//this.db.setTimeData(this.show_code, tsValues);
				//console.log("Client Time: " + (+new Date()) + "  Server Time: " + data.timestamp + "  Difference: " + (+new Date() - data.timestamp)+ "  Clock Difference: " + (this.socketClock - data.timestamp));
			};
		}
		this.socket.onopen = () => {
			console.log('WebSocket connect:');
			if (this.socket) {
				this.timestampStartTime = (+ new Date());
				tsValues.T1_Client = this.timestampStartTime;
				this.socket.send("timestamp");
			}
		};
		// this.showService.getTimestamp().subscribe(response => {
		// 	let ts = (+ new Date());
		// 	this.timeDifference = ts - response.timestamp;
		// 	console.log(this.timeDifference);
		// });
		this.subscription = this.secondsCounter.subscribe(n => {
			if (this.loaded) {
				if (this.show.start_from_beginning) {
					if (this.wave && this.wave.getDuration()) {
						if (!this.wave?.isPlaying()) {
							this.wave.play()
						}
					}
					return;
				}
				this.showService.getShowJson(this.show).subscribe(data => {
					const status = data.split(',');
					if (status[0] === 'play' || status[0] === 'resume') {
						if (!this.wave?.isPlaying()) {
							let t = Number(status[2]);
							const playTime = (+ new Date()) - Number(status[1]);
							if (this.wave && this.wave.getDuration()) {
								if (!this.show.looping && ((+ new Date()) - Number(status[1])) > 0 && ((+ new Date()) - Number(status[1])) < this.audioLength * 1000 || this.show.looping && Number(status[1]) < (+ new Date())) {
									let seekTime = (+(new Date()) - Number(status[1]) + Number(status[2])) % (this.audioLength * 1000)
									this.playerStartTriggerTs = (seekTime - this.timeDifference) / 1000
									this.wave.setTime((seekTime - this.timeDifference) / 1000);
									this.wave.play()
								}
								else {
									this.show.status = "stop";
								}
							}
						}
						else {
							//calibrationCount
							// if(this.wave){
							// 	let seekTime = (+(new Date()) - Number(status[1]) + Number(status[2])) % (this.audioLength*1000) - this.timeDifference
							// 	this.playerStartTriggerTs = (seekTime)/1000
							// 	if(this.calibrationCount < 20){
							// 		//console.log(seekTime)
							// 		//console.log(seekTime + " | " + this.wave.getCurrentTime() + " = " + (seekTime - this.wave.getCurrentTime()*1000))
							// 		//this.wave.setTime((seekTime)/1000);
							// 		//this.wave.pause();
							// 		//this.wave.play();
							// 		this.calibrationCount++;
							// 	}
							// }
						}
					}
					else if (status[0] == 'pause') {
						this.played = true;
						if (!this.interacting) {
							this.wave?.setTime((status[2] - this.timeDifference) / 1000 + this.adjustment);
							//this.wave?.seekTo(((status[2] - this.timeDifference) / 1000 + this.adjustment + this.globalAdjustment + this.defaultAdjustment) / this.audioLength);
						}
						if (this.wave?.isPlaying()) {
							this.wave?.pause()
						}
						else {
						}
					}
					else {
						if (this.wave?.getCurrentTime() && !this.interacting) {
							this.wave?.stop()
						}
						else {
						}
					}
				})
			}
		});
		try {
			this.db.getData(this.show.show_code).subscribe((response: any) => {
				if (response && response.messageText) {
					this.announcementComment = response.messageText;
				}
			});
		} catch (error) {
			console.log(error)
		}

	}

	ngAfterViewInit(): void {
		this.route.params.subscribe(params => {
			if (params['show_code']) {
				this.show_code = params['show_code'].toUpperCase();
				 	this.showService.getSingleShow(this.show_code).subscribe((response: any) => {
						console.log('response',response);
						this.subscription_plan = response.subscription;
						this.loder = true;
						this.db.getData(this.show_code).subscribe((response: any) => {
							if (response && response.messageText) {
								this.announcementComment = response.messageText;
							}
						});
						if (response) {
							this.show = response;
							if (this.show.brand) {
								this.brand = this.show.brand
								//this.font.family = this.brand.font_family;
								this.font.family = "Roboto"
							}
							if (this.show.created_date) {
								this.show.created_date_ts = new Date(this.show.created_date.split(' ')[0] + "T" + this.show.created_date.split(' ')[1] + "+00:00");
							}
							if (this.show.show_date) {
								this.show.show_date_ts = new Date(this.show.show_date.split(' ')[0] + "T" + this.show.show_date.split(' ')[1] + "+00:00");
							}
							this.show.audio_file_name = response.audio_file_info.file_name;
							this.loadFileInfo();
						}
					}, (error) => {
						this.loaded = true;
					});
			}
		});


	}
	goToSubscription() {
		this.router.navigate(['/subscription']);
	}
	userGesture() {
		const dialogRef = this.dialog.open(ConfirmPopupComponent, {
			id: 'confirm-play',
			maxWidth: '600px',
			width: '95%',
			data: {
				title: 'Audio Player',
				message: 'Show is started and will be played in the on your phone.',
			}
		});
		dialogRef.componentInstance.onConfirm.subscribe(result => {
			if (result) {
				dialogRef.close();

			}
		});
	}
	versionedImage(url: string) {
		return url + "?v=" + Math.random();
	}
	ngOnDestroy() {
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}
	loadFileInfo() {
		if (this.show?.audio_file_id && this.show?.audio_file_name) {
			this.showService.getFileInfo(this.show?.audio_file_id, this.show).subscribe((response: any) => {
				this.fileInfo = response;
				this.audioLength = Number(this.fileInfo.file_duration)
				//this.init();
			}, () => {
				if (this.retried <= 6) {
					this.retried++;
					setTimeout(() => {
						this.loadFileInfo();
					}, 5000)
				}
				else {
					this.loadingError = true;
				}
			})
		}
	}
	init() {
		this.previewStart();
		this.buttonVisible = false;
	}
	previewStart(): void {
		if (!this.wave) {
			this.generateWaveform();
		}

		this.cdr.detectChanges();

		Promise.resolve().then(() => {
			if (this.wave) {
				//this.wave.load((this.fileInfo.timecode_channel === 'right' ? this.fileInfo.timecode_file_url : this.fileInfo.file_url))//+'?v='+Math.random()
				this.wave.load((this.fileInfo.timecode_channel === 'right' ? this.fileInfo.timecode_file_url : (this.fileInfo.aac_file_url ? this.fileInfo.aac_file_url : this.fileInfo.file_url)))//+'?v='+Math.random()
			}
		});
	}

	generateWaveform(): void {
		Promise.resolve(null).then(() => {
			this.wave = WaveSurfer.create({
				container: '#waveform',
				waveColor: this.isTune2 ? '#DE072A' : (!this.isPyrocast ? '#0f57c6' : '#2cbcf4'),
				progressColor: this.isTune2 ? '#830008' : (!this.isPyrocast ? '#03238a' : '#03238a'),
				interact: false,
				plugins: [
					TimelinePlugin.create({
						container: '#wave-timeline'
					})
				]
			});
			this.wave.on('loading', (progress) => {
				this.progress = progress
			});
			this.wave.on('ready', () => {
				if (this.wave) {
					this.loaded = true;
					if (!this.downloadLogged) {
						this.showService.logDownload(this.show.show_id).subscribe((response: any) => {
							this.downloadLogged = true;
						});;
					}
					if (!this.audioLength) {
						this.audioLength = Math.round(this.wave.getDuration() * 1000)
					}
					this.cdr.detectChanges();
				}
			});
			this.wave.on('play', () => {
				this.played = true;
				if (!this.listenLogged) {
					this.showService.logListen(this.show.show_id).subscribe((response: any) => {
						this.listenLogged = true;
					});
				}
				if (this.wave) {
					console.log(this.audioLength)
					console.log(this.wave.getDuration())
					console.log(this.wave.getCurrentTime() - this.playerStartTriggerTs)
				}
				this.timestampStartTime = +new Date();
				this.calibrate(1);
				// setTimeout(() => {
				// 	if(this.wave){
				// 		console.log(this.wave.getCurrentTime() - this.playerStartTriggerTs - 0.5)
				// 	}
				// }, 500);
				// setTimeout(() => {
				// 	if(this.wave){
				// 		console.log(this.wave.getCurrentTime() - this.playerStartTriggerTs - 1)
				// 	}
				// }, 1000);
				// setTimeout(() => {
				// 	if(this.wave){
				// 		console.log(this.wave.getCurrentTime() - this.playerStartTriggerTs - 2)
				// 	}
				// }, 2000);
				// setTimeout(() => {
				// 	if(this.wave){
				// 		let diff = this.wave.getCurrentTime() - this.playerStartTriggerTs - 3
				// 		console.log(diff)
				// 		this.wave.setTime(this.playerStartTriggerTs + 3)
				// 		setTimeout(() => {
				// 			if(this.wave){
				// 				console.log(this.wave.getCurrentTime() - this.playerStartTriggerTs - 6)
				// 			}
				// 		}, 3000);
				// 	}
				// }, 3000);
			});
			this.wave.on('audioprocess', () => {
				this.updateTimer();
			})
			this.wave.on('seeking', () => {
				this.updateTimer();
			})
			this.wave.on('finish', () => {
				if (this.show && !this.show.looping) {
					this.show.status = "stop";
				}
				else {
					this.wave?.play();
				}
			});
		});
	}

	calibrate(n: any) {
		setTimeout(() => {
			console.log(+new Date() - this.timestampStartTime);
			if (this.wave) {
				let diff = this.wave.getCurrentTime() - this.playerStartTriggerTs - n * 0.5
				console.log(diff)
				if (n == 6) {
					this.wave.setTime(this.playerStartTriggerTs + n * 0.5 - diff)
					setTimeout(() => {
						if (this.wave) {
							let diff = this.wave.getCurrentTime() - this.playerStartTriggerTs - 8
							console.log(diff)
						}
					}, 5000)
					setTimeout(() => {
						if (this.wave) {
							let diff = this.wave.getCurrentTime() - this.playerStartTriggerTs - 3.5
							console.log(diff)
						}
					}, 500)
				}
				if (n < 6) {
					n++;
					this.calibrate(n)
				}
			}
		}, 500);
	}
	updateTimer() {
		if (this.wave) {
			this.seekTime = new Date(this.wave.getCurrentTime() * 1000 + this.timeOffset);
			this.cdr.detectChanges();
		}
	}
	adjust(add: boolean) {
		this.adjustment += (add ? 1 : -1) * 0.1;
		if (this.wave && this.wave.getCurrentTime() > 0) {
			this.wave.skip((add ? 1 : -1) * 0.1);
		}
	}

	showDomainOnly(url: any) {
		return url.replace('http://', '').replace('https://', '').split('/')[0];
	}

	nl2br(str: any) {
		return str ? str.replace(/(?:\r\n|\r|\n)/g, '<br>') : '';
	}


}
